/* eslint-disable newline-before-return */
import { FC, ChangeEvent, useState } from 'react';
import { Grid, TextArea, Button } from 'semantic-ui-react';

const Component: FC = () => {
  const [count, setCount] = useState(0);
  const [text, setText] = useState('');
  const [translated, setTranslate] = useState('');
  const translate = async () => {
    const method = 'POST';
    const headers = {
      Accept: '*/*',
      'Content-Length': '[length]',
      'Content-Type': 'application/x-www-form-urlencoded',
    };
    const response = await fetch(
      `https://api-free.deepl.com/v2/translate?auth_key=672102e3-322c-0ac6-ed57-cd76118b8d6f:fx&text=${text}&target_lang=JA`,
      { method, headers }
    );
    const json = await response.json();
    setTranslate(json.translations[0].text);
  };

  return (
    <>
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <TextArea
              placeholder="Memo"
              style={{ minHeight: 100, width: '100%' }}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns="equal">
          <Grid.Column width={8}>
            <TextArea
              placeholder="English Sentence"
              style={{ minHeight: 500, width: '100%' }}
              onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
                setText(event.target.value);
                setCount(
                  event.target.value === ''
                    ? 0
                    : event.target.value.split(' ').length
                );
              }}
            />
          </Grid.Column>
          <Grid.Column width={8}>
            <TextArea
              value={translated}
              placeholder="翻訳"
              style={{ minHeight: 500, width: '100%' }}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns="equal">
          <Grid.Column width={2}>
            <b>{count}文字</b>
          </Grid.Column>
          <Grid.Column width={2}>
            <Button content="翻訳" color="blue" onClick={translate} />
          </Grid.Column>
          <Grid.Column width={4}>
            <Button
              content="翻訳クリア"
              secondary
              color="blue"
              onClick={() => setTranslate('')}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
};

export default Component;
